<div class="wrapper">
	<div class="header-wrapper">
		<h2 class="title">{{ 'select_products_promo' | translate }}</h2>
		<!-- <p class="description">
        {{ 'recom_art.desc' | translate }}
      </p> -->
	</div>
	<div class="content_block">
		<ion-row>
			@for (article of articlesList; track trackBy(i, article); let i = $index) {
				<ion-col size="6">
					@if (article?.isActive && article?.visible) {
						<div [class.selected]="showAmount(article) > 0" class="card-item">
							<ion-icon
								[class.active]="showAmount(article) > 0"
								class="selected_item_icon"
								src="../../../assets/topgolf/selected.svg"
							>
							</ion-icon>
							<p class="price">
								{{ isFromPrice(article) ? ('item_view.price_from' | translate) : '' }} {{ reloadPriceNew(article) }}
							</p>
							<div class="image-block">
								@if (article.assets.medium) {
									<ion-img [src]="article.assets.medium" class="item_img"></ion-img>
								}
								@if (!article.assets.medium) {
									<ion-img class="default-img" src="../../../assets/topgolf/full_logo.svg"></ion-img>
								}
								<ion-icon
									[src]="
										article.assets.medium ? '../../../assets/topgolf/add-button.svg' : '../../../assets/icon/plus.svg'
									"
									class="plus"
								></ion-icon>
							</div>
							<div class="info-block">
								<h3 class="name">
									{{ article.name | langObservable | async }}
								</h3>
							</div>
							<div class="footer-section">
								@if (showAmount(article) === 0) {
									<div (click)="selectArticle(article)" class="add-button">
										<p>{{ 'add_promo' | translate }}</p>
									</div>
								}
								@if (showAmount(article) > 0) {
									<div class="quantity-selector">
										<ion-icon
											(click)="decreaseQuantity(article)"
											class="quantity-btn"
											src="../../../assets/icon/minus.svg"
										></ion-icon>
										<p class="quantity">{{ showAmount(article) }}</p>
										<!-- <ion-icon
                                        class="quantity-btn"
                                        (click)="increaseQuantity(article)"
                                      src="../../../assets/icon/plus.svg"></ion-icon> -->
									</div>
								}
							</div>
						</div>
					}
				</ion-col>
			}
		</ion-row>
	</div>

	<div class="footer-btn">
		<!-- <ion-button (click)="addArticlesToBasket()">{{ 'recom_art.btn_yes' | translate
      }}</ion-button> -->
		<ion-button (click)="addArticlesToBasket()" class="cancel-btn">{{ 'add_promo_dialog.add' | translate }} </ion-button>
	</div>
</div>
